// Private staff-portal path. Change REACT_APP_ADMIN_PATH in frontend/.env to rotate it.
// The public /admin/* path returns 404 when a custom portal path is set.
export const ADMIN_PORTAL = process.env.REACT_APP_ADMIN_PATH || "/admin";
